import { FaMapMarkerAlt, FaLaptopMedical } from "react-icons/fa";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
const ConnectWithUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div>
      {/* Top Banner */}
      <section data-aos="fade-in">
        <div className="bg-gradient-to-r from-[#51B3AA] to-[#019890] text-white px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
          {/* Left Side: Heading */}
          <h2 className="text-xl md:text-2xl font-bold uppercase text-center md:text-left">
            VISIT OR CONNECT <br className="hidden md:block" /> WITH US
          </h2>

          {/* Right Side: Info */}
          <div className="flex flex-col md:flex-row items-center md:space-x-8 gap-2 md:gap-0 text-sm md:text-base text-center md:text-left">
            <h3 className="font-semibold">Butterfly Wellness</h3>

            <span className="flex items-center space-x-2">
              <FaMapMarkerAlt className="text-white" />
              <p>Coimbatore, Tamil Nadu</p>
            </span>

            <span className="flex items-center space-x-2">
              <FaLaptopMedical className="text-white" />
              <p>Online Therapy Available</p>
            </span>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="bg-white px-6 md:px-12 py-12">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8 md:gap-10">
          
        {/* Left Text */}
        <div className="text-center md:text-left">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 leading-snug">
            BEGIN YOUR{" "}
            <span className="hidden md:inline"><br /></span>
            JOURNEY TO{" "}
            <span className="hidden md:inline"><br /></span>
            WELLNESS
        </h2>
        </div>


          {/* Right Content */}
          <div className="max-w-xl text-gray-700 flex flex-col items-center md:items-start text-center md:text-left">
            <p className="mb-4 text-sm md:text-base leading-relaxed">
              Whether you're struggling silently or consciously seeking change, you are not
              alone. Let us help you explore what’s holding you back—and gently guide you
              toward clarity, strength, and inner peace.
            </p>
            <p className="mb-6 md:mb-8 text-sm md:text-base leading-relaxed">
              You deserve to feel safe, balanced, and whole.
            </p>
            <a
              href="https://wa.me/919952753900"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-4 sm:px-6 py-3 bg-[#005CA8] text-white font-semibold rounded hover:opacity-90 transition inline-block text-center"
            >
              Transform With Us
            </a>
          </div>

        </div>
      </section>
    </div>
  );
};

export default ConnectWithUs;
